// extracted by mini-css-extract-plugin
export default {"main":"styles_main__v-CrV","breadCrumbsContainer":"styles_breadCrumbsContainer__MFxj7","paper":"styles_paper__Bdk4X"};